export { default as balls } from './loading-balls.svg'

export { default as bars } from './loading-bars.svg'

export { default as beat } from './loading-beat.svg'

export { default as bubbles } from './loading-bubbles.svg'

export { default as cylon } from './loading-cylon.svg'

export { default as spin } from './loading-spin.svg'

export { default as spiningDubbles } from './loading-spining-dubbles.svg'

export { default as barsCylon } from './loading-bars-cylon.svg'
